import styled from 'styled-components';
import { breakpoint } from 'styles/globals';

export const Wrapper = styled.div`
   display: flex;
   flex-direction: column;

  .presented-by-banner {
    padding: 0 0 24px;
    @media (${breakpoint.lgMin}) {
      padding: 0;
    }
  }
`;

export const Header = styled.div`
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 24px;
  
  @media (${breakpoint.mdMin}) {
    margin-left: 32px;
    margin-right: 32px;
  }
  @media (${breakpoint.lgMin}) {
    margin-left: 0;
    margin-right: 0;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 48px;
  gap: 24px;

  &.crypto, &.europe, &.asia, &.well {
    margin-top: 0;
  }

  @media (${breakpoint.hybridMin}) {
    flex-direction: row;
  }

  @media (${breakpoint.lgMax}) {
    margin-top: 24px;

    &.crypto {
      margin-top: 0;
    }
  }
`;

// TODO: I don't like these selectors here
export const Content = styled.div`
  max-width: 100%;
  width: 100%;

  .article-card.hero .card-wrapper {
    padding: 0 16px;

    @media (${breakpoint.mdMin}) {
      padding: 0 24px;
    }

    @media (${breakpoint.hybridMin}) {
      padding: 0;
    }    
  }

  @media (${breakpoint.hybridMin}) {
    width: calc(100% - 360px);
  }

  & > .features {
    margin-top: 8px;
  }

  & > .features ~ .features {
    margin-top: 0px;
  }

  & > .features {
    @media (${breakpoint.mdMin}) {
      margin-top: 0px;
    }
  }

  & > .features > div,
  & > .features > h1,
  & > .features > h2 {
    @media (${breakpoint.mdMin}) {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }
  }

  .exploreModule + .features {
    .heading {
      margin-top: 0px;
    }

    @media (${breakpoint.mdMin}) {
      .heading {
        margin-top: 48px;
      }
    }

  }

  .exploreModule + div > .newsletter-grid {
    margin-top: 0px;
  }
`;

export const SidebarTablet = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  & > .sidebar-content-preview {
    flex: 1 1 50%;
    width: 50%;
    box-sizing: border-box;
    border-left: 0;
    margin-left: 0;
    padding-left: 0;
  }

  .editors-picks {
    margin: 0 16px;
    @media (${breakpoint.mdMin}) {
      margin: 48px 0 0 0;
      padding-right: 24px;
      max-width: 50%;

      :only-child {
        max-width: 100%;
      }
    }
  }

  .newsletter-grid {
    margin-top: 48px;
    @media (${breakpoint.mdMin}) {
      margin: 48px 0 0 0;
      padding-right: 24px;

      :only-child {
        max-width: 100%;
      }
    }
  }

  .video-module {
    margin: 48px 16px 0;

    @media (${breakpoint.mdMin}) {
      margin: 48px 0 0 0;
      padding-left: 24px;

      :only-child {
        max-width: 100%;
      }
    }
  }
`;

export const SidebarMobile = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  .simple-homepage:nth-of-type(1) {
    margin-top: 32px;
  }

  .simple-homepage {
    margin-top: 8px;
  }

  .newsletter-grid {
    margin-top: 24px;
    margin-bottom: 0px;

    ul {
      margin-bottom: 0px;
    }
  }

  .video-module {
    margin-bottom: 0px;
  }

  .editors-picks {
    margin-top: 32px;
    margin-bottom: 0px;
  }

  .exploreModule {
    margin-bottom: 32px;
  }
`;

export const Tout = styled.div<{ $url?: string | undefined }>`
  margin: 48px 16px 0px;
  cursor: pointer;
  display: flex;
  justify-content: center;

  &.europe, &.asia, &.well {
    content: url('${(props) => (props ? props.$url : '')}');
    margin: auto;
    margin-top: 48px;
    max-width: 100%;

    @media (${breakpoint.mmMin}) {
      padding: 0 16px;
    }

    @media (${breakpoint.mdMin}) {
      padding: unset;
    }
  }

    &.crypto {
      svg {
        max-width: 100%;
        width: 1000px;
        height: auto;
      }
    }
`;

export const ToutButton = styled.div`
  width: 100%;
  margin-top: 16px;
  display: flex;

  .black-button {
    text-transform: unset;
    width: 178px;
    line-height: 19px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin: auto;
  }

  &.europe {
    margin-top: 16px;
  }
`;

export const ToutContainer = styled.div`
  min-height: 298px;

  @media (${breakpoint.mmMin}) {
    min-height: unset;
    aspect-ratio: 995 / 301;
  }
`;
